module.exports = __webpack_public_path__ + "static/media/18ECA27.6d9cf19f.jpg";